function isDesktop() {
  if (window.innerWidth > 1024) {
    return true;
  }

  return false;
}

function handleWheelEvent(container) {
  container.addEventListener('wheel', (wheelEvent) => {
    wheelEvent.preventDefault();
    const delta = wheelEvent.deltaY || wheelEvent.detail || wheelEvent.wheelDelta;
    const scrollSpeed = 0.5;
    container.scrollLeft += delta * scrollSpeed;
  });
}

export const wheelScrollEvent = (e) => {
  if (!isDesktop()) {
    return;
  }

  const facetPanelContentContainer = e.target.closest('.cm_button-container');

  if (!facetPanelContentContainer) {
    return;
  }

  handleWheelEvent(facetPanelContentContainer);
};

let activeContainer = null;
let startX = 0;
let scrollLeft = 0;
let isScrolling = false;

export const mouseDownEvent = (e) => {
  if (!isDesktop()) {
    return;
  }

  const facetPanelContentContainer = e.target.closest('.cm_button-container');
  if (facetPanelContentContainer) {
    startX = e.pageX - facetPanelContentContainer.offsetLeft;
    ({ scrollLeft } = facetPanelContentContainer);
    activeContainer = facetPanelContentContainer;
    facetPanelContentContainer.classList.add('active');
    isScrolling = false;
  }
};

export const mouseMoveEvent = (e) => {
  if (!activeContainer || !isDesktop()) {
    return;
  }

  e.preventDefault();
  const x = e.pageX - activeContainer.offsetLeft;
  const step = x - startX;
  activeContainer.scrollLeft = scrollLeft - step;

  if (Math.abs(step) > 5) {
    isScrolling = true;
  }
};

export const mouseUpEvent = () => {
  if (!isDesktop()) {
    return;
  }

  if (activeContainer) {
    activeContainer.classList.remove('active');
    activeContainer = null;
  }
};

export const mouseLeaveEvent = (e) => {
  if (!isDesktop()) {
    return;
  }

  const facetPanelContentContainer = e.target.closest('.cm_button-container');
  if (facetPanelContentContainer) {
    mouseUpEvent();
  }
};

export const clickEvent = (e) => {
  if (!isDesktop()) {
    return;
  }

  if (isScrolling) {
    e.preventDefault();
    e.stopPropagation();
    isScrolling = false;
    return false;
  }
};

export const collapseMobileContent = (e) => {
  if (isDesktop()) {
    return;
  }

  const button = e.target.closest('.cm_facet-title');

  // get field name from class list
  const fieldName = button.classList[1]?.split('-')[1];

  // find clicked button content
  const facetPanelContent = window.document.querySelector(
    `.cm_FacetPanel__header-mobile .cm_facets-content .cm_facet-facetbody-${fieldName}`,
  );

  const allContentContainers = window.document.querySelectorAll(
    '.cm_FacetPanel__header-mobile .cm_facets-content .cm_facet-facetbody',
  );

  // collapse all opened content, not current clicked content
  allContentContainers.forEach((content) => {
    if (content !== facetPanelContent) {
      content.classList.add('collapsed');
    }
  });

  const facetPanelButtons = window.document.querySelectorAll(
    '.cm_FacetPanel__header-mobile .cm_facet-title:not(.cm_mobile-hide)',
  );

  // collapse all opened buttons, not current clicked button
  facetPanelButtons.forEach((btn) => {
    const btnFieldName = btn.classList[1]?.split('-')[1];
    if (btnFieldName !== fieldName) {
      btn.classList.add('collapsed');
    }
  });

  const isCollapsed = facetPanelContent.classList.contains('collapsed');

  // open button content
  facetPanelContent.classList.toggle('collapsed', !isCollapsed);
  button.classList.toggle('collapsed', !isCollapsed);
};

export const handleArrows = (e, isLeftArrow) => {
  const facetPanelContentContainer = e.target.parentElement.querySelector('.cm_button-container');

  if (facetPanelContentContainer) {
    facetPanelContentContainer.scrollBy({
      left: isLeftArrow ? -200 : 200,
      behavior: 'smooth',
    });
  }
};
